<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const route = useRoute()

const handleNextStep = async () => {
  await handleNext('tutorial_resources_trade')
}

const isOnResourcesSection = computed(() => {
  return route.path.startsWith('/resources')
})
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        Another way to obtain certain ores/materials is to trade them.
      </p>
      <p class="pb-2">
        This is done trough the Galactic Ore Exchange. You can exchange any ore against another ore of the same level for a fee.
      </p>
      <p class="pb-2">
        The higher the level of the ore, the more expensive the fee is.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Click on the "trade" button below any ore you wish to have more of, then click on "trade" to select which ore you wish to exchange. Finally set the number of ore you wish to exchange every week and press "set".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Done!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>